import React, { useEffect, useState, useCallback } from "react";
import "../../styles/faculty-types/main.css";
import { getAllFaculty, getAllFacultyById } from "../../Services/AllAPIs";
import { Link, useParams } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner";

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [faculty, setFaculty] = useState(null);
    const [error, setError] = useState(null);
    const { id } = useParams();
    const [otherFaculties, setOtherFaculties] = useState([]);

    // Function to fetch faculty data by id, memoized with useCallback
    const getFacultyById = useCallback(() => {
        getAllFacultyById(id)
            .then((res) => {
                console.log("Faculty Data:", res.data);
                setFaculty(res.data);
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error fetching faculty:", error);
                setError("An error occurred while fetching faculty data.");
                setLoader(false);
            });
    }, [id]);

    // Function to fetch all faculties and filter out the current faculty, memoized with useCallback
    const getFaculty = useCallback(() => {
        getAllFaculty()
            .then((res) => {
                const facultyData = Object.values(res.data.faculty);
                // console.log("Faculty Data:", facultyData);
                const filteredFaculties = facultyData.filter(
                    (facultyItem) => facultyItem.id !== id
                );
                setOtherFaculties(filteredFaculties);

                setLoader(false);
            })
            .catch((error) => {
                // console.error("Error fetching faculty:", error);
                setError("An error occurred while fetching faculty data.");
                setLoader(false);
            });
    }, [id]);

    useEffect(() => {
        getFacultyById();
        getFaculty();
    }, [id, getFacultyById, getFaculty]); // Adding getFaculty and getFacultyById to the dependency array

    return (
        <div id="facultyTypesMain">
            <div className="faculty-type-heading mt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2
                                className="my-heading"
                                style={{ paddingLeft: 10, color: "black" }}
                            >
                                FACULTIES
                            </h2>
                            <p
                                className="text-left"
                                style={{ paddingLeft: 10, paddingRight: 35, color: "black" }}
                            >
                                Chaudhary Charan Singh University (CCSU), formerly known as
                                Meerut University, is a renowned institution in India offering a
                                diverse range of academic disciplines through its various
                                faculties.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Faculty Details */}
            <div className="faculty-types">
                <div className="container faculty-types-main">
                    {loader && <LoadingSpinner />}
                    {error && <div className="error">{error}</div>}

                    {faculty ? (
                        <div className="row">
                            <div className="col-md-6 faculty">
                                <div className="faculty-heading" style={{ display: "block" }}>
                                    <img
                                        src={faculty.logo}
                                        alt={faculty.name}
                                        className="img-fluid"
                                    />
                                </div>
                                <div className="faculty-content">
                                    <h5>FACULTY OF {faculty.name}</h5>
                                </div>
                            </div>
                            <div className="col-md-6">
                                {/* Additional faculty details could go here */}
                            </div>
                        </div>
                    ) : (
                        <div>No faculty available for this ID.</div>
                    )}

                    <div className="accordion" id="accordionExample">
                        {faculty &&
                            faculty.departments &&
                            faculty.departments.length > 0 ? (
                            faculty.departments.map((department, index) => {
                                // Determine the link for the department
                                const link = department.website
                                    ? department.website
                                    : `/faculty/${department.url_id}/department/${department.url_id}`;

                                return (
                                    <div className="card" key={department.id}>
                                        <div
                                            className="card-header"
                                            id={`heading${department.id}`}
                                            style={{
                                                backgroundColor: "#d9e6f6",
                                                borderBottom: "1.5px solid #14297a",
                                            }}
                                        >
                                            <Link
                                                to={link}
                                                style={{ color: "#000", textDecoration: "none" }}
                                            >
                                                <i
                                                    className="fa-solid fa-circle-plus"
                                                    style={{ marginRight: 5 }}
                                                />
                                                Department of <b>{department.name}</b>
                                            </Link>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="card">
                                <div className="card-body">
                                    No departments available for this faculty.
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Other Faculties Section */}
            <div className="container faculty-links">
                <div
                    style={{
                        marginTop: 80,
                        position: "relative",
                        width: "100%",
                        backgroundColor: "#f0f6fd",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        borderRadius: 8,
                        gap: 5,
                        boxShadow:
                            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                        padding: "15px 15px",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: "-23px",
                            left: 30,
                            backgroundColor: "#14297a",
                            color: "#FFF",
                            width: 180,
                            textAlign: "center",
                            fontSize: "large",
                            fontWeight: 500,
                            borderRadius: 8,
                            zIndex: -1,
                        }}
                    >
                        Other Faculties
                    </div>
                    {/* Rendering other faculties */}
                    {otherFaculties.length > 0 ? (
                        otherFaculties.map((faculty, index) => (
                            <Link
                                key={faculty.id}
                                style={{ textDecoration: "none" }}
                                to={`/faculty/${faculty.url_id}`}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                        width: 135,
                                        padding: "0 10px",
                                        height: 135,
                                        backgroundColor: "#FFF",
                                        borderRadius: 20,
                                        boxShadow: "box-shadow: 0px 4px 4px 0px #00000040",
                                    }}
                                >
                                    <div>
                                        <img
                                            src={faculty.logo}
                                            alt={faculty.name}
                                            style={{ height: 50, width: 50 }}
                                        />
                                    </div>
                                    <p
                                        id="otherFcaultyName"
                                        style={{
                                            color: "#14297a",
                                            fontFamily: "Roboto, sans-serif",
                                            fontSize: 12,
                                            padding: "0 !important",
                                            margin: "0 !important",
                                            fontWeight: "800 !important",
                                            textAlign: "center",
                                        }}
                                    >
                                        Faculty of {faculty.name.toUpperCase()}
                                    </p>
                                </div>
                            </Link>
                        ))
                    ) : (
                        <div>No other faculties available.</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Main;
